export default {"src":"/_next/static/media/cat-plus.5a1d12e5.svg","height":812,"width":900};